/* eslint-disable check-file/filename-naming-convention */
/* eslint-disable @typescript-eslint/naming-convention */

export const Selectors = {
	Checkbox: 'ui-kit-checkbox',
	Dropdown: 'ui-kit-dropdown',
	DropdownItem: 'ui-kit-dropdown-item',
	Input: 'ui-kit-input',
	Radio: 'ui-kit-radio',
	SelectableList: 'ui-kit-selectable-list',
	SelectableListItem: 'ui-kit-selectable-list-item',
	Switch: 'ui-kit-switch',
	TextArea: 'ui-kit-text-area',
	InputAutocomplete: 'ui-kit-input-autocomplete',
};
